export class ApplicationConstants {
    public static COLOR_WHITE = '#F3F3F3';
    public static COLOR_MILD_RED = '#ff4000';
    public static ROADMAP_UNDERWRITING_API_URL = '/v1/underwriting/roadmap?details=true';
    public static UNDERWRITING_TXN_API_URL = '/v1/underwriting/roadmap/transaction/';
    public static UNDERWRITING_GET_TXN_INFO_API_URL = '/v1/underwriting/roadmap/transaction/account/';
    public static FUSE_API_URL = '/v1/fuse/account/';
    public static DRAFT_OPTIMIZATION_API_URL = '/v1/draft-optimization/clients/';
}